module.exports = __webpack_public_path__ + "c2996b7dccb933362a15534f7efea8dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tsp-social-share.png
// module id = 1934
// module chunks = 0